import { ModalsWrapperContext } from "@kanda-libs/ks-component-ts";
import { MODAL_ID } from "./constants";
import { useContext } from "react";

export interface CompanyReportButtonHook {
  onShowModal: () => void;
}

export default function useCompanyReportButton(): CompanyReportButtonHook {
  const { showModal } = useContext(ModalsWrapperContext);

  const onShowModal = () => {
    showModal(MODAL_ID);
  };

  return {
    onShowModal,
  };
}
